module.exports = __webpack_public_path__ + "img/team-mates.40fa0d6d.svg";